import { gql } from '@apollo/client';

import {
  GetPollResultDocument,
  type GetPollResultQuery,
  type GetPollResultQueryVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    query GetPollResult($id: UUID!) {
      pollResults(id: $id) {
        distribution {
          count
          value
        }
        totalResponses
      }
    }
  `;
}

export const GET_POLL_RESULT = GetPollResultDocument;
export type { GetPollResultQuery, GetPollResultQueryVariables };
